/**
 * The one pressed/unpressed look for filter pills: the coach's Standups
 * filters, the tracker's bet switch and its channel switch.
 */
const PILL_SELECTED =
  'bg-indigo-50 border-indigo-500 text-indigo-800 font-semibold dark:bg-indigo-950 dark:border-indigo-400 dark:text-indigo-200';
const PILL_IDLE =
  'bg-white border-gray-300 text-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300';

export function togglePillClass(isSelected: boolean) {
  return `px-3 py-1 rounded-full border text-sm ${isSelected ? PILL_SELECTED : PILL_IDLE}`;
}
